import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { generateGpMainUrl } from "~/utils/url";
import { ModalHeader } from "./styles_vanilla.css";

export type Props = {
  arenaName: string;
  arenaSubdomain: string;
  entityId: number;
  onClose: () => void;
  showModal: boolean;
};

const EntitySettingsNotRestrictModal = (props: Props) => {
  const { arenaName, arenaSubdomain, entityId, onClose, showModal } = props;
  const onClick = () => {
    const gpMainUrl = generateGpMainUrl(arenaSubdomain);
    const gpUrl = `${gpMainUrl}/account/${entityId}`;
    window.open(gpUrl, "_blank");
  };
  return (
    <ModalV2
      show={showModal}
      onHide={onClose}
      isCentered={true}
      size="small"
      title="Warning"
      visuallyHideTitle
      headerClassName={ModalHeader}
      headerIconProps={{
        type: "exclamation-circle",
        size: "xxx-large",
        color: Colors.Danger600,
        variant: "solid",
      }}
    >
      <Flex justifyContent="center" gap={8} flexDirection="column">
        <Text
          align="center"
          variant="h2"
        >{`Transfer accounting needs to be turned off in ${arenaName}’s workspace`}</Text>
        <Text align="center" variant="secondary-md">
          Go to the entity and turn off transfer accounting under metrics settings to sync
          transfers.
        </Text>
      </Flex>
      <Flex flexDirection="column" style={{ marginTop: "24px" }} gap={8}>
        <Button onClick={onClick} variant="primary" icon="external-link" iconPosition="right">
          Go to entity
        </Button>
        <Button onClick={onClose} variant="neutral">
          Cancel
        </Button>
      </Flex>
    </ModalV2>
  );
};

export default EntitySettingsNotRestrictModal;
